'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var channels = exports.channels = {
  title: 'Canales',
  background_url: 'https://dev-res.thumbr.io/images/channels-banner.jpg?brightness=-50',
  description: 'Disfruta de los mejores cursos de Universidades y Organizaciones.',
  make_your_own: 'O crea tu propio canal y difunde tu contenido al mundo.',
  schools_title: 'Universidades',
  schools_description: 'Aprende con las mejores universidades del mundo y mejora tu formación en cualquier disciplina, con MOOCs y Vídeocursos gratuitos a tu alcance.',
  schools_view_all: 'Ver todas las Universidades',
  schools_create_title: '¿Interesado en crear tu propia Universidad?',
  schools_create_description: 'Servicio disponible para entidades educativas certificadas.',
  schools_create_icon: 'https://lib.tutellus.com/images/icons/university.svg',
  schools_create_cta: '¡Resérvala!',
  organizations_title: 'Organizaciones',
  organizations_description: 'Encuentra los mejores contenidos en vídeo de las empresas, asociaciones y fundaciones que abren su conocimiento para crear un mundo mejor.',
  organizations_view_all: 'Ver todas las Organizaciones',
  organizations_create_title: 'Crea ya tu canal en Tutellus. ¡Es gratis!',
  organizations_create_description: 'Servicio disponible para empresas y marcas.',
  organizations_create_icon: 'https://lib.tutellus.com/images/icons/channel.svg',
  organizations_create_cta: '¡Resérvalo!',
  courses_title: 'Cursos',
  teachers_title: 'Profesores'
};


//////////////////
// WEBPACK FOOTER
// ../i18n/lib/es/channels.js
// module id = 696
// module chunks = 0